export default __webpack_public_path__ + "static/media/cocktailSelection.56002035.jpg";